// ============================================================
// Wallet provider detection
// Prioritises injected mobile DEX wallets (Trust Wallet, MetaMask,
// Binance, SafePal, TokenPocket, Coinbase, etc.).
// ============================================================

export const detectInjected = () => {
  if (typeof window === 'undefined') return null;
  const eth = window.ethereum;
  if (!eth) return null;

  // If multiple providers are injected, EIP-5749 exposes an array.
  const providers = eth.providers;
  if (Array.isArray(providers) && providers.length) {
    return (
      providers.find((p) => p.isTrust) ||
      providers.find((p) => p.isMetaMask && !p.isBraveWallet) ||
      providers.find((p) => p.isBinance) ||
      providers.find((p) => p.isSafePal) ||
      providers.find((p) => p.isTokenPocket) ||
      providers.find((p) => p.isCoinbaseWallet) ||
      providers[0]
    );
  }
  return eth;
};

export const walletName = (p) => {
  if (!p) return 'Wallet';
  if (p.isTrust) return 'Trust Wallet';
  if (p.isBinance) return 'Binance Wallet';
  if (p.isSafePal) return 'SafePal';
  if (p.isTokenPocket) return 'TokenPocket';
  if (p.isCoinbaseWallet) return 'Coinbase Wallet';
  if (p.isMetaMask) return 'MetaMask';
  return 'Wallet';
};

export const isMobile = () => {
  if (typeof navigator === 'undefined') return false;
  return /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent);
};

export const isInAppBrowser = () => {
  const p = detectInjected();
  return !!p && isMobile();
};
